// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__NG-_T","label":"input_label__27dZy","err":"input_err__KvIgg","boder_err":"input_boder_err__3y5aT"};